'use client';
import React from 'react';
import dynamic from 'next/dynamic';

interface CSRChartProps {
  csr: number;
  insurerName: string;
}

const CSRChartInner = dynamic(() => import('./CSRChartInner'), { ssr: false });

export default function CSRChart({ csr, insurerName }: CSRChartProps) {
  return <CSRChartInner csr={csr} insurerName={insurerName} />;
}